import { useQuery } from "@tanstack/react-query";

import { DeveloperApplication, DeveloperApplicationDetail, api } from "../api";

export function useApplicationInventory(organizationId: string, enabled = true) {
  return useQuery({
    queryKey: ["developer-application-inventory", organizationId],
    queryFn: async () => {
      const list = await api<{ applications: DeveloperApplication[] }>(
        `/api/v1/organizations/${organizationId}/applications`,
      );
      return Promise.all(list.applications.map((application) => api<DeveloperApplicationDetail>(
        `/api/v1/organizations/${organizationId}/applications/${application.id}`,
      )));
    },
    enabled,
  });
}
